import {
	catchError, Observable, of, tap,
} from 'rxjs';

import { AuthService, Container, Service } from '../../../../symphony';

import { getInitialServerSideData } from '../../../../shared/public/SlUtils/getInitialServerSideData';
import { SlApiService } from '../sl-api.service';
import { SlDataService } from '../sl-data.service';
import { SlLEContext } from '../../global-constants';
import { LanguagesResponseType } from '../../../../api/public/static-pages-api';

@Service()
export class SlLanguageService {
	private api = Container.take(SlLEContext, SlApiService);

	private dataService = Container.take(SlLEContext, SlDataService);

	public authService = Container.take('global', AuthService);

	public getProgrammingLanguages = (): Observable<LanguagesResponseType> => {
		const { loading$, programmingLanguages$ } = this.dataService;

		const ssrLanguagesList = getInitialServerSideData('ssrLanguagesList');

		if (ssrLanguagesList) {
			programmingLanguages$.next(ssrLanguagesList);
			return of(null);
		}

		loading$.next({ getProgrammingLanguages: true });

		return this.api.getLanguages().pipe(
			tap((languages) => {
				this.dataService.programmingLanguages$.next(languages);
				loading$.next({
					...loading$.value,
					getProgrammingLanguages: false,
				});
			}),
			catchError(() => {
				loading$.next({
					...loading$.value,
					getProgrammingLanguages: false,
				});
				return of(null);
			}),
		);
	};
}
